import React from 'react';
import 'bootstrap';
import 'aos'
import '../assets/css/style.css';
import ozone from '../assets/img/Customer-logos/ozone.png';
import orbion from '../assets/img/Customer-logos/orbion.png';
import amneal from '../assets/img/Customer-logos/amneal.png';
import azurity from '../assets/img/Customer-logos/azurity.png';
import arene from '../assets/img/Customer-logos/arene.png';
import catalyst from '../assets/img/Customer-logos/catalysts.png';
import daichel from '../assets/img/Customer-logos/daichel.jpg';
import east from '../assets/img/Customer-logos/east.png';
import energon from '../assets/img/Customer-logos/energon.jpg';
import gng from '../assets/img/Customer-logos/Genext_gng.png';
import inventia from '../assets/img/Customer-logos/inventia.png';
import maiva from '../assets/img/Customer-logos/maiva.jpg';
import nawal from '../assets/img/Customer-logos/nawal.png';
import proantek from '../assets/img/Customer-logos/proantek.png';
import salicylates from '../assets/img/Customer-logos/salicylates.png';
import sms from '../assets/img/Customer-logos/sms.png';
import tyche from '../assets/img/Customer-logos/tyche_logo.png';
import umed from '../assets/img/Customer-logos/umed.jpg';
import iirndf from '../assets/img/Customer-logos/iirndf.jpg';
import doah from '../assets/img/Customer-logos/doah.png';
import niper from '../assets/img/Customer-logos/niper.png';
import hyconlabs from '../assets/img/Customer-logos/hyconlabs.webp';
import VKT_Pharma from '../assets/img/Customer-logos/VKT_Pharma.png';
import CYDMAX from '../assets/img/Customer-logos/CYDMAX.jpg';
import xylopia from '../assets/img/Customer-logos/Xylopia.png';
import zydus from '../assets/img/Customer-logos/zydus.png';
import belco from '../assets/img/Customer-logos/belco.png';


const CustomerLogos = () => {

    return (
        <React.Fragment>
            <div className='customer-logos-div'>
                <div className="customer-logos-title">
                    <h6> - Trusted by -</h6>

                    <div className="logo-carousel">
                        <div className="logo-track">
                            <div className="logo-item"><img src={ozone} alt="ozone" /></div>
                            <div className="logo-item"><img src={orbion} alt="orbion" style={{height:'2.5rem'}}/></div>
                            <div className="logo-item"><img src={amneal} alt="amneal" /></div>
                            <div className="logo-item"><img src={azurity} alt="azurity" /></div>
                            <div className="logo-item"><img src={arene} alt="arene" /></div>
                            <div className="logo-item"><img src={catalyst} alt="catalyst" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={daichel} alt="daichel" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={east} alt="east ocyon bio" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={energon} alt="energon" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={iirndf} alt="IIRNDF" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={doah} alt="DOAH" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={hyconlabs} alt="hyconlabs" style={{height:'3.5rem'}}/></div>
                            <div className="logo-item"><img src={VKT_Pharma} alt="VKT_Pharma" style={{height:'3rem'}}/></div>

                            {/* loop */}
                            <div className="logo-item"><img src={ozone} alt="ozone" /></div>
                            <div className="logo-item"><img src={orbion} alt="orbion" style={{height:'2.5rem'}}/></div>
                            <div className="logo-item"><img src={amneal} alt="amneal" /></div>
                            <div className="logo-item"><img src={azurity} alt="azurity" /></div>
                            <div className="logo-item"><img src={arene} alt="arene" /></div>
                            <div className="logo-item"><img src={catalyst} alt="catalyst" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={daichel} alt="daichel" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={east} alt="east ocyon bio" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={energon} alt="energon" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={iirndf} alt="IIRNDF" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={doah} alt="DOAH" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={hyconlabs} alt="hyconlabs" style={{height:'3.5rem'}}/></div>
                            <div className="logo-item"><img src={VKT_Pharma} alt="VKT_Pharma" style={{height:'3rem'}}/></div>
                        </div>
                    </div>

                    <div className="logo-carousel">
                        <div className="logo-track-2">
                            <div className="logo-item"><img src={gng} alt="GNG" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={inventia} alt="inventia" style={{height:'2.5rem'}}/></div>
                            <div className="logo-item"><img src={maiva} alt="maiva" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={umed} alt="umed" style={{height:'3.5rem'}}/></div>
                            <div className="logo-item"><img src={salicylates} alt="salicylates" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={belco} alt="belco" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={nawal} alt="nawal" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={proantek} alt="proantek" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={sms} alt="sms" /></div>
                            <div className="logo-item"><img src={tyche} alt="tyche" style={{height:'2rem',marginTop:'0.5rem'}}/></div>
                            <div className="logo-item"><img src={niper} alt="niper" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={CYDMAX} alt="CYDMAX" style={{height:'3.5rem'}}/></div>
                            <div className="logo-item"><img src={xylopia} alt="xylopia" style={{height:'3.5rem'}}/></div>
                            <div className="logo-item"><img src={zydus} alt="zydus" style={{height:'3.5rem'}}/></div>

                            {/* loop */}
                            <div className="logo-item"><img src={gng} alt="" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={inventia} alt="inventia" style={{height:'2.5rem'}}/></div>
                            <div className="logo-item"><img src={maiva} alt="maiva" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={umed} alt="umed" style={{height:'3.5rem'}}/></div>
                            <div className="logo-item"><img src={salicylates} alt="salicylates" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={belco} alt="belco" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={nawal} alt="nawal" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={proantek} alt="proantek" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={sms} alt="sms" /></div>
                            <div className="logo-item"><img src={tyche} alt="tyche" style={{height:'2rem',marginTop:'0.5rem'}}/></div>
                            <div className="logo-item"><img src={niper} alt="niper" style={{height:'4rem'}}/></div>
                            <div className="logo-item"><img src={CYDMAX} alt="CYDMAX" style={{height:'3.5rem'}}/></div>
                            <div className="logo-item"><img src={xylopia} alt="xylopia" style={{height:'3.5rem'}}/></div>
                            <div className="logo-item"><img src={zydus} alt="zydus" style={{height:'3.5rem'}}/></div>
                        </div>
                    </div>

                   
                </div>
            </div>
            
        </React.Fragment>
    )
}

export default CustomerLogos
